/**
 * Danh sách các chứng từ chưa sinh hạch toán
 */
export default {
  All: 0,
  CAReceipt: 20, //  20
  CAPayment: 21, //  21
};
